<mat-icon class="warning-icon material-icons-outlined">report</mat-icon>

<ng-content />
